<template>
  <div class="">
    <div class="container d-flex justify-content-center" v-if="!!getSaleUnits && getSaleUnits > 0">
      <div class="discount-section row  align-items-center">
        <h5>Apply a Discount (Optional)</h5>
        <div class="discount-box d-flex justify-content-between gap-1">
          <p @click="openDiscount" v-if="!discountApplied">Tap to apply a discount</p>
          <p v-else>{{ discountText }}</p>
          <div class="d-flex justify-content-end gap-3">
            <a v-if="discountApplied" class="icon text-danger" @click="clearDiscount">
              <font-awesome-icon icon="fa-solid fa-xmark"/>
            </a>
            <a class="icon" @click="openDiscount">
              <font-awesome-icon icon="fa-solid fa-chevron-right"/>
            </a>
          </div>
        </div>
      </div>
    </div>
    <DiscountSheet ref="discount"/>
    <div class="sale-details">
      <div class="sale-detail-label"><h6>Sale Total({{ getSaleUnits }})</h6></div>
      <div class="sale-detail-value"><h4>{{ $utils.formatMoney(saleTotal - discount.total) }}</h4></div>
    </div>
  </div>
</template>

<script>
import DiscountSheet from "@/components/point-of-sale/sales/Discount/DiscountSheet";

export default {
  name: "SaleDetails",
  components: {DiscountSheet},
  computed: {
    getSaleUnits() {
      return this.$store.getters.getSaleUnits
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal
    }, discount() {
      return this.$store.getters.getSaleDiscount
    },
    discountText() {
      let discount = this.discount
      return `${discount.type} (${discount.type === 'Percentage' ? `${discount.value}%` : discount.value})`;
    },
    discountApplied() {
      return this.discount.type !== 'none'
    },
  },
  methods: {
    openDiscount() {
      this.$refs.discount.open();
    },
    clearDiscount() {
      this.$store.commit('clearDiscount')
    },
  }
}
</script>

<style lang="scss" scoped>
.sale-details {
  display: grid;
  grid-gap: 5px 10px;
  padding: 10px;
  //grid-template-columns: 50% 50%;
  width: 100%;
  grid-template-columns: 35% 65%;

  .sale-detail-label {
    text-align: left;
  }

  .sale-detail-value {
    text-align: right;
    padding-right: 18px;
  }
}

h4, h5, h6 {
  margin: 0;
}

h4 {
  font-weight: 700;
}

.discount-btn {
  background: #0069d9;
  color: white;
  height: fit-content;
}

.discount-section {
  width: 420px;
  justify-content: center;

  .discount-box {
    width: 100%;
    min-width: 300px;
    padding: 10px;
    border: 2px solid lightgrey;
    height: 50px;
    border-radius: 10px;

    p {
      margin: 0;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
